import localizationStorage from '%app/js/common/services/localizationStorage';
import { DIRECTION_LTR, DIRECTION_RTL } from '%evp_theme/brandbook/material/config/constants';

function resolveTextDirection() {
    return localizationStorage.isCurrentLanguageRtl() ? DIRECTION_RTL : DIRECTION_LTR;
}

export default resolveTextDirection;
